export const generateCode = (prefix='') => {
  const ts = new Date().getTime();
  const str = `${srand()}${srand()}${ts}`;

  return `${prefix}${str.slice(0,12)}`;
}

const srand = () => {
  return Math.floor(Math.random() * 9 ) + 1;
}
